import React, { useState } from 'react';
import { FloatingPanel, PanelSection } from '../ui/Panel';
import { Button } from '../ui/Button';
import { NumberInput, Slider } from '../ui/Input';

/**
 * FireSafetyEditor - Editor panel for fire & life safety symbol properties
 */
export const FireSafetyEditor = ({
  item,
  onUpdate,
  onDelete,
  onClose,
  x = 20,
  y = 100,
  isMobile = false,
}) => {
  const [minimized, setMinimized] = useState(isMobile);

  if (!item) return null;

  return (
    <FloatingPanel
      title={item.name || 'Fire / Safety Symbol'}
      onClose={onClose}
      onMinimize={() => setMinimized(!minimized)}
      minimized={minimized}
      x={x}
      y={y}
      isMobile={isMobile}
    >
      <div style={{ padding: '12px' }}>
        <PanelSection title="Size">
          <NumberInput
            label="Symbol Size"
            value={item.size || 12}
            onChange={(size) => onUpdate({ size })}
            min={4}
            max={48}
            step={1}
            suffix="in"
          />
        </PanelSection>

        <PanelSection title="Rotation">
          <Slider
            value={item.rotation || 0}
            onChange={(rotation) => onUpdate({ rotation })}
            min={0}
            max={360}
            step={15}
            suffix="°"
          />
          <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
            {[0, 90, 180, 270].map((r) => (
              <Button
                key={r}
                variant="default"
                onClick={() => onUpdate({ rotation: r })}
                style={{ flex: 1, fontSize: '11px' }}
              >
                {r}°
              </Button>
            ))}
          </div>
        </PanelSection>

        <PanelSection title="Label">
          <input
            type="text"
            value={item.code ?? ''}
            onChange={(e) => onUpdate({ code: e.target.value })}
            placeholder="Code (e.g., FE, S, EXIT)"
            style={{
              width: '100%',
              padding: '6px 8px',
              background: 'rgba(0,0,0,0.3)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '4px',
              color: '#fff',
              fontSize: '12px',
            }}
          />
        </PanelSection>

        <PanelSection title="Color">
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {[
              { c: '#d62828', name: 'Fire Red' },
              { c: '#16a34a', name: 'Egress Green' },
              { c: '#2563eb', name: 'Sprinkler Blue' },
              { c: '#7c2d12', name: 'Detection Brown' },
              { c: '#1a1a1a', name: 'Black' },
            ].map((swatch) => (
              <button
                key={swatch.c}
                onClick={() => onUpdate({ color: swatch.c })}
                title={swatch.name}
                style={{
                  width: 28,
                  height: 28,
                  background: swatch.c,
                  border: item.color === swatch.c ? '2px solid #00c8ff' : '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        </PanelSection>

        <PanelSection title="Actions">
          <Button
            variant="danger"
            onClick={onDelete}
            style={{ width: '100%' }}
          >
            Delete
          </Button>
        </PanelSection>
      </div>
    </FloatingPanel>
  );
};

export default FireSafetyEditor;
